@if (limitsLoading()) {
  <div class="promocode-generator promocode-generator--skeleton">
    <div class="promocode-generator__skeleton promocode-generator__skeleton--slider"></div>
    <div class="promocode-generator__skeleton promocode-generator__skeleton--button"></div>
  </div>
} @else {
  @if (limits(); as limits) {
    <div class="promocode-generator">
      <div class="promocode-generator__values">
        <div class="promocode-generator__value">
          <span class="promocode-generator__value-amount text-b2-s-700">{{ bonusPercent() }}%</span>
          <span class="promocode-generator__value-label text-b3-s-500">мой бонус</span>
        </div>

        <div class="promocode-generator__value promocode-generator__value--discount">
          <span class="promocode-generator__value-amount text-b2-s-700">{{ discountPercent() }}%</span>
          <span class="promocode-generator__value-label text-b3-s-500">скидка клиента</span>
        </div>
      </div>

      <div
        class="promocode-generator__slider-wrapper"
        [style.--slider-progress.%]="sliderProgress()"
        [style.--slider-ratio]="sliderRatio()"
      >
        <input
          class="promocode-generator__slider"
          type="range"
          aria-label="скидка клиента, %"
          [min]="limits.discountPercentMinimum"
          [max]="limits.discountPercentMaximum"
          [step]="limits.stepPercent"
          [value]="discountPercent()"
          [disabled]="generating()"
          (input)="changeDiscountPercent($event)"
        />

        <span class="promocode-generator__slider-value text-b2-s-700" aria-hidden="true">{{ discountPercent() }}%</span>
      </div>

      <button
        class="promocode-generator__button"
        sdButton
        size="l"
        theme="outlined"
        [fullWidth]="true"
        [loading]="generating()"
        [disabled]="generating()"
        (click)="generatePromocode()"
      >
        сгенерировать промокод
      </button>
    </div>
  }
}
